import { SupportedChainId } from '@orionprotocol/sdk';

export function isSupportedChainId(
  chainId: unknown,
): chainId is SupportedChainId {
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  return Object.values(SupportedChainId).includes(chainId as SupportedChainId);
}
